import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Banknote, Palette, Package, TrendingUp, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: Banknote, label: "Connect Stripe securely" },
  { icon: Palette, label: "Customize your storefront" },
  { icon: Package, label: "Add your first product" },
  { icon: TrendingUp, label: "Start selling" },
];

export default function Welcome() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== "seller") navigate("/", { replace: true });
  }, [user, navigate]);

  return (
    <div data-testid="welcome-page" className="max-w-xl mx-auto px-6 py-20 lg:py-28 text-center">
      <div className="text-5xl mb-6" aria-hidden="true">🎉</div>
      <h1 className="font-serif text-4xl lg:text-5xl tracking-tight">Welcome to Alteza!</h1>
      <p className="text-base text-muted-foreground mt-4">
        It only takes about 5 minutes to open your store.
      </p>

      <div className="mt-10 text-left bg-card border border-border rounded-sm p-6 lg:p-8">
        <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground mb-5">You’ll</div>
        <ul className="space-y-4">
          {STEPS.map(({ icon: Icon, label }) => (
            <li key={label} className="flex items-center gap-4">
              <span className="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5" />
              </span>
              <span className="text-base">{label}</span>
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={() => navigate("/seller", { replace: true })}
        data-testid="get-started-btn"
        className="btn-primary mt-10 px-8 py-3.5 text-sm rounded-sm inline-flex items-center gap-2"
      >
        Get Started <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
